var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button-group',{ref:"mapheaders",staticClass:"map-sub-tier-headers",attrs:{"id":"mapheaders"}},_vm._l((_vm.subTiers),function(subtier){return _c('MapSubTierHeader',{key:subtier.path.toString(),attrs:{"id":subtier.name,"details":subtier,"data-cy":"map-subtier-header"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }